import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d566251a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d566251a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d566251a')) {
      api.createRecord('d566251a', component.options)
    } else {
      api.reload('d566251a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d566251a&scoped=true", function () {
      api.rerender('d566251a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/api/index.vue"
export default component.exports